/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_Anything_HintInputs */

const en_directory_search_anything_hint = /** @type {(inputs: Directory_Search_Anything_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Names, businesses and descriptions`)
};

const pl_directory_search_anything_hint = /** @type {(inputs: Directory_Search_Anything_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazwiska, firmy i opisy`)
};

/**
* | output |
* | --- |
* | "Names, businesses and descriptions" |
*
* @param {Directory_Search_Anything_HintInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_anything_hint = /** @type {((inputs?: Directory_Search_Anything_HintInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_Anything_HintInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_anything_hint(inputs)
	return en_directory_search_anything_hint(inputs)
});